export default __webpack_public_path__ + "static/media/sort-descending.051e9d4e.svg";